module.exports = __webpack_public_path__ + "files/c8c9e372c4926893b21a1d5f7c258f01.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-4.png
// module id = 533
// module chunks = 76